import { render, staticRenderFns } from "./talents_details2.vue?vue&type=template&id=2f068bee&scoped=true"
import script from "./talents_details2.vue?vue&type=script&lang=js"
export * from "./talents_details2.vue?vue&type=script&lang=js"
import style0 from "./talents_details2.vue?vue&type=style&index=0&id=2f068bee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f068bee",
  null
  
)

export default component.exports